var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ds-status',{staticClass:"status-label",attrs:{"emphasis":"high","data-qa":`${_vm.broadcastSubject}-status`,"type":_vm.broadcastStatusType}},[_vm._v(" "+_vm._s(_vm.broadcastStatusMessage)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }